import { render, staticRenderFns } from "./FiltersBar.vue?vue&type=template&id=6816b7bb&"
import script from "./FiltersBar.vue?vue&type=script&lang=js&"
export * from "./FiltersBar.vue?vue&type=script&lang=js&"
import style0 from "./FiltersBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports